import {
  Bell,
  Check,
  GraduationCap,
  FileText,
  Award,
  ClipboardCheck,
  AlertTriangle,
  ShieldCheck,
  RefreshCw,
} from 'lucide-react';
import type { NotificationType } from '@/types';

// Filtros, opciones e iconos de notificaciones. Extraído por ENG-LOC-01.

export const READ_FILTERS = [
  { label: 'Todas', value: undefined },
  { label: 'Sin Leer', value: false },
  { label: 'Leídas', value: true },
] as const;

export const TYPE_OPTIONS: { label: string; value: NotificationType | undefined }[] = [
  { label: 'Todos los tipos', value: undefined },
  { label: 'Inscripción', value: 'enrollment' },
  { label: 'Recordatorio', value: 'reminder' },
  { label: 'Vencimiento', value: 'overdue' },
  { label: 'Cambio Documento', value: 'document_change' },
  { label: 'Solicitud Aprobación', value: 'approval_request' },
  { label: 'Decisión Aprobación', value: 'approval_decision' },
  { label: 'Evaluación', value: 'assessment_request' },
  { label: 'Competencia', value: 'competency_issued' },
  { label: 'Acción Correctiva', value: 'corrective_action' },
  { label: 'Recurrencia', value: 'training_recurring' },
  { label: 'Actualización Capacitación', value: 'course_update' },
];

export const TYPE_ICONS: Record<NotificationType, typeof Bell> = {
  enrollment: GraduationCap,
  reminder: Bell,
  overdue: AlertTriangle,
  document_change: FileText,
  approval_request: ClipboardCheck,
  approval_decision: Check,
  assessment_request: ClipboardCheck,
  competency_issued: Award,
  corrective_action: AlertTriangle,
  training_recurring: RefreshCw,
  course_update: ShieldCheck,
};

export const PREF_FIELDS = [
  { key: 'email_enrollment' as const, label: 'Inscripciones nuevas' },
  { key: 'email_reminder' as const, label: 'Recordatorios' },
  { key: 'email_overdue' as const, label: 'Vencimientos' },
  { key: 'email_document_change' as const, label: 'Cambios de documentos' },
  { key: 'email_approval' as const, label: 'Aprobaciones' },
  { key: 'email_assessment' as const, label: 'Evaluaciones' },
  { key: 'email_competency' as const, label: 'Competencias' },
  { key: 'email_course_update' as const, label: 'Actualización de capacitaciones' },
];
